import { isYMEnabled } from './is-ym-enabled';
import { pushStoreCode } from './push-store-code';

export const pushStoreCodeIfEnabled = (code: string): void => {
  if (isYMEnabled() && !!code) {
    pushStoreCode(code);
  }
};